import { jsx as _jsx } from "react/jsx-runtime";
export const ArrowDown2Icon = ({ color = 'currentColor', size = 14, ref, ...props }) => {
    return (_jsx("svg", { ...props, width: size, height: size, ref: ref, stroke: color, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M2.79999 4.9L6.99999 9.1L11.2 4.9", strokeWidth: "1.6" }) }));
};
//# sourceMappingURL=arrow-down2-icon.js.map